import { Link } from 'react-router-dom';
import { Separator } from '../components/ui/separator';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Calendar } from 'lucide-react';
import { NavBar } from '../components/NavBar';
import { Footer } from '../components/Footer';
import { PageHead } from '../components/PageHead';
import { StructuredData, breadcrumb } from '../components/StructuredData';
import '../App.css';

export function AtelierPage() {
  return (
    <div className="App">
      <PageHead
        title="L'Atelier – Lunetterie du Russey | Opticien indépendant Haut-Doubs"
        description="Opticienne diplômée depuis 18 ans au Russey (25210). Magasin indépendant, montures françaises Origine France Garantie, partenaire Essilor. Découvrez notre savoir-faire artisanal."
        image="/photo-elise.jpg"
      />
      <StructuredData data={breadcrumb([
        { name: 'Accueil', path: '/' },
        { name: "L'Atelier", path: '/atelier' },
      ])} />
      <NavBar />

      <section className="atelier-section page-section-first">
        <div className="atelier-content">
          <div className="atelier-text">
            <Badge className="section-badge">Votre Opticien Expert</Badge>
            <h1 className="atelier-title">Un Savoir-Faire Artisanal au Cœur du Haut-Doubs</h1>
            <p className="atelier-description">
              Magasin indépendant, opticienne diplômée depuis 18 ans à votre service. Vaste sélection
              de montures françaises, labellisées "Origine France Garantie". Partenaire Essilor,
              nouveau progressif XR Design à découvrir.
            </p>
            <Separator className="my-6" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
            <p className="atelier-description">
              Installée au pôle santé du Russey depuis 2014, la Lunetterie du Russey s'est construite
              autour d'une conviction : proposer des équipements de qualité, fabriqués en France,
              adaptés à chaque patient. Le Haut-Doubs mérite un opticien à sa hauteur.
            </p>
            <div className="atelier-features">
              <div className="atelier-feature">
                <div className="atelier-feature-number">18</div>
                <div className="atelier-feature-label">Années d'expérience</div>
              </div>
              <div className="atelier-feature">
                <div className="atelier-feature-number">100%</div>
                <div className="atelier-feature-label">Indépendant</div>
              </div>
              <div className="atelier-feature">
                <div className="atelier-feature-number">FR</div>
                <div className="atelier-feature-label">Made in France</div>
              </div>
            </div>
            <div style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <Button asChild className="bg-[var(--color-rust)] hover:opacity-90 text-white">
                <Link to="/contact">
                  <Calendar className="mr-2 h-4 w-4" />
                  Prendre rendez-vous
                </Link>
              </Button>
              <Button asChild variant="outline" className="border-white text-white hover:bg-white/10">
                <Link to="/collections">Voir nos collections</Link>
              </Button>
            </div>
          </div>
          <div className="atelier-images">
            <img
              src="https://images.pexels.com/photos/5715905/pexels-photo-5715905.jpeg?w=600"
              alt="Opticienne au travail – ajustement et montage de lunettes à la Lunetterie du Russey"
              className="atelier-image atelier-image-1"
            />
            <img
              src="/photo-elise.jpg"
              alt="Élise, opticienne diplômée depuis 18 ans au Russey, Haut-Doubs (25210)"
              className="atelier-image atelier-image-2"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
